import { mapGetters } from 'vuex'
import { reviewerInvite } from '@/api/reviewer'

export default {
  data() {
    return {
      inputData: {}
    }
  },
  computed: {
    ...mapGetters({
      reviewRefuse: 'getReviewRefuse'
    })
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      let id = this.$route.params.id
      let data = await reviewerInvite.refuse(id)
      this.inputData = data
    },
    confirm() {
      this.$router.back(-1)
    }
  }
}
